routes.$inject = ['$stateProvider'];

var templateUrl = require('./templates/main.html');
var tAndCUrl = require('./pages/tandc.html');
var tOfEUrl = require('./pages/tofe.html');
var privacyUrl = require('./pages/privacy.html');
var privacyStatementUrl = require('./pages/privacy_statement.html');

var clinicTAndCUrl = require('../clinic/pages/tandc.html');
var clinicPrivacyUrl = require('../clinic/pages/privacy.html');

export default function routes($stateProvider) {
  $stateProvider
    .state('app', {
      url: '/app',
      templateUrl: templateUrl,
      controller: 'AppController',
      controllerAs: 'appCtrl'
    })
    .state('app.tandc', {
      url: '/tandc',
      templateUrl: tAndCUrl
    })
    .state('app.tofe', {
      url: '/tofe',
      templateUrl: tOfEUrl
    })
    .state('app.privacy', {
      url: '/privacy',
      templateUrl: privacyUrl
    })
    .state('app.privacyStatement', {
      url: '/privacyStatement',
      templateUrl: privacyStatementUrl
    })
    .state('app.referral-file-download', {
      url: '/referral/download-extra-file/{file:\\d+}',
    })
    .state('app.original-referral-download', {
      url: '/referral/download-referral/{hmr:[A-Z]*\\d+}/:item',
    })
    .state('clinic', {
      url: '/clinic',
      templateUrl: templateUrl,
      controller: 'AppController',
      controllerAs: 'clinicCtrl'
    })
    .state('clinic.tandc', {
      url: '/tandc',
      templateUrl: clinicTAndCUrl
    })
    .state('clinic.privacy', {
      url: '/privacy',
      templateUrl: clinicPrivacyUrl
    })
  ;
}



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/app/app.routes.js
 **/